import React from 'react'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from 'UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import AntdTooltip from 'UI/Tooltip/Tooltip'
import { InfoCircleOutlined } from '@ant-design/icons'

export const ecommerceExtendedColumns = [
  {
    ...columns[COLUMNS_IDS.profileNames],
    title: (
      <>
        <span>Online Name</span>
        <AntdTooltip title='Names used by entity/individual online' placement='bottom' color='#fff'>
          <InfoCircleOutlined style={{ color: '#B8AFAF', marginLeft: '6px' }} />
        </AntdTooltip>
      </>
    ),
  },
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.ecommerceTaxCollection],
  columns[COLUMNS_IDS.ecommerceSellerRegStatus],
  columns[COLUMNS_IDS.ecommerceRegistry],
  columns[COLUMNS_IDS.ecommerceRiskScore],
  columns[COLUMNS_IDS.ecommerceMagnitudeScore],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.ecommerceShopCategories],
  columns[COLUMNS_IDS.ecommerceAddressNexus],
  columns[COLUMNS_IDS.ecommerceEmployeesNexus],
  columns[COLUMNS_IDS.ecommerceNumberOfShops],
  columns[COLUMNS_IDS.ecommerceAddresses],
  columns[COLUMNS_IDS.websiteRanking],
  columns[COLUMNS_IDS.ecommerceNumberOfEmployees],
  columns[COLUMNS_IDS.ecommerceAvgMonthlyCountryTraffic],
  columns[COLUMNS_IDS.ecommerceAvgMonthlyTraffic],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  ecommerceExtendedColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
